import blockquote, { blockquoteVariants, type BlockquoteVariantsType } from './blockquote';
import type { Util } from '../../../types/util';

const quote = {
  blockquote,
};

export const quoteVariants = {
  blockquote: blockquoteVariants,
};

export type QuoteComponentsType = 'blockquote';

export interface QuoteType {
  /** The Accordion subcomponent types. */
  SubComponents: {
    [K in QuoteComponentsType]: Util.VariantKeyModes<K extends 'blockquote' ? BlockquoteVariantsType : never>;
  };
  /** The Blockquote types. */
  Blockquote: Util.VariantKeys<BlockquoteVariantsType>;
}

export default quote;
